import { CapoPlugin } from "/home/forge/oase-aej.de/releases/81992485/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];